export class PinnedMeetingProviderService {
    static $inject = ['$location', 'graph-group-factory', 'graph-webinar-factory', 'graph-exhibition-factory'];

    constructor(
        private $location: ng.ILocationService,
        private groupFactory: any,
        private webinarFactory: any,
        private exhibitionFactory: any
    ) {}

    public getPinnedMeetingId(): Promise<number | null> {
        const exhibitionId = this.getExhibitionId();
        if (exhibitionId) {
            return this.exhibitionFactory
                .meeting(exhibitionId)
                .then((response: ng.IHttpResponse<any>) => response.data.state === 0 && response.data.data.id);
        }

        const webinarId = this.getWebinarId();
        if (webinarId) {
            return this.webinarFactory
                .meeting(webinarId)
                .then((response: ng.IHttpResponse<any>) => response.data.state === 0 && response.data.data.id);
        }

        const groupId = this.getGroupId();
        if (groupId) {
            return this.groupFactory
                .meeting(groupId)
                .then((response: ng.IHttpResponse<any>) => response.data.state === 0 && response.data.data.id);
        }

        return Promise.resolve(this.parseUrlMeetingId());
    }

    /**
     * return webinar id if is currently on webinar page
     * @private
     */
    private getWebinarId() {
        const path = this.$location.path();
        const matches = path.match(/\/webinar\/(\d+)\/?/i);
        return matches !== null ? parseInt(matches[1]) : null;
    }

    /**
     * return exhibition id if is currently on exhibition page
     * @private
     */
    private getExhibitionId() {
        const path = this.$location.path();
        const matches = path.match(/\/exhibition\/(\d+)\/?/i);
        return matches !== null ? parseInt(matches[1]) : null;
    }

    /**
     * return group id if is currently on group page
     * @private
     */
    private getGroupId() {
        const path = this.$location.path();
        const matches = path.match(/\/group\/(\d+)\/?/i);
        return matches !== null ? parseInt(matches[1]) : null;
    }

    private parseUrlMeetingId() {
        const path = this.$location.path();
        const matches = path.match(/\/meeting\/(\d+)\/?/i);
        return matches !== null ? parseInt(matches[1]) : null;
    }
}

angular.module('tradersyard').service('PinnedMeetingProviderService', PinnedMeetingProviderService);
